import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "./Reveal";

export function FaqBlock({ items, title }) {
  const { pick, t } = useLang();
  return (
    <section className="py-20" data-testid="faq-section">
      <div className="pn-container max-w-3xl">
        <Reveal>
          <p className="overline">FAQ</p>
          <h2 className="mt-3 font-head text-3xl font-medium tracking-tight md:text-4xl text-[#16181D]">
            {title || t("common.faq")}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-8">
            {items.map((it, i) => (
              <AccordionItem key={i} value={`q${i}`} data-testid={`faq-${i}`} className="border-b border-[#e4e9f0]">
                <AccordionTrigger className="text-left font-head text-base font-medium text-[#16181D] hover:text-[#E2611C] hover:no-underline">
                  {pick(it.q)}
                </AccordionTrigger>
                <AccordionContent className="text-[#4a4d52] leading-relaxed">{pick(it.a)}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}

export function faqSchema(items, pick) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: pick(it.q),
      acceptedAnswer: { "@type": "Answer", text: pick(it.a) },
    })),
  };
}
